import React from 'react';
import PropTypes from 'prop-types';
import LineItems from '../components/LineItems';
import translator from '../translations/drupalTranslator';
import {OPTIONAL, UPON_ARRIVAL} from '../constants/ServicesPaymentTime';

const BookingOverviewOwnServiceContainer = ({order, rental, className, subtotalClassName}) => {
  // @todo extract to a shared utility.
  const calculatedAmount = (lineItems) => {
    let amount = 0;

    for (const item in lineItems) {
      if (lineItems.hasOwnProperty(item)) {
        let roundedNumber = Math.round((lineItems[item].price.amount + Number.EPSILON) * 100) / 100;
        amount += parseFloat(roundedNumber * lineItems[item].unitCount);
      }
    }

    return amount;
  };

  const uponArrivalServices = order.services.filter(service =>
    (service.paymentTime === UPON_ARRIVAL ||
    service.paymentTime === OPTIONAL) &&
    (service.obligatory &&
    service.unitCount === 0 &&
    service.unitPrice.amount > 0))
    .map((service) => {
      const updatedService = {...service};
      if (updatedService.price.amount < updatedService.minimumPrice.amount) {
        updatedService.price = updatedService.minimumPrice;
      }

      if (updatedService.price.amount === 0 && updatedService.unitPrice.amount > 0) {
        updatedService.price = updatedService.unitPrice;
      }

      updatedService.unitCount = 1;
      return updatedService;
    });;

  const lineItems = uponArrivalServices.map(service => ({...service}));

  let payOnArrivalName = lineItems.some(e => e.type === 'NOVASOL') && rental.isDanishProperty ?
    translator.translate('Pay in MyBooking') :
    translator.translate('Pay on arrival');

  // Add the subtotal line to the items.
  const afterArrivalLineItems = lineItems.length ? lineItems.concat(
    [{
      name: payOnArrivalName,
      price: {
        amount: calculatedAmount(lineItems),
        currencyCode: lineItems[0].price.currencyCode,
      },
      serviceId: 'afterArrival',
      unitCount: 1,
      className: subtotalClassName,
    }]
  ) : false;

  return afterArrivalLineItems ? (
<section className="booking-overview__section pay-after-items">
      <LineItems
        className={className}
        lineItems={afterArrivalLineItems}
      />
</section>
  ): null;
};

BookingOverviewOwnServiceContainer.PropTypes = {
  order:PropTypes.object.isRequired,
  className:PropTypes.string.isRequired,
  subtotalClassName:PropTypes.string.isRequired,
};

export default BookingOverviewOwnServiceContainer;
